import * as React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useLanguage } from "../Language";

interface FourOhThreePageProps {
  message?: string;
}

export class ForbiddenError extends Error {
  constructor(message = "Forbidden") {
    super(message);
    this.name = "ForbiddenError";
  }
}

export const FourOhThreePage: React.FC<FourOhThreePageProps> = function ({ message }) {
  const { translate } = useLanguage();
  return (
    <Container>
        <Box sx={{ textAlign: "center", mt: 4 }}>
            <Typography variant="h1" fontWeight={700}>403</Typography>
            <Typography variant="h4" gutterBottom>{translate("Forbidden")}</Typography>
            {message && <Typography variant="h4" gutterBottom>{message}</Typography>}
        </Box>
      </Container>
  );
};
